module.exports = __webpack_public_path__ + "img/exit.e47485d0.svg";